// Mock data for Microworld Solution Inc

export const computerBrands = [
  { id: 1, name: 'Dell', description: 'Complete support for Dell desktops, laptops, and workstations. Hardware diagnostics, driver updates, and performance optimization.' },
  { id: 2, name: 'HP', description: 'Expert HP support including Pavilion, Envy, Omen, and EliteBook series. BIOS updates, hardware troubleshooting, and repairs.' },
  { id: 3, name: 'Lenovo', description: 'ThinkPad, IdeaPad, and Yoga series support. System optimization, hardware upgrades, and technical assistance.' },
  { id: 4, name: 'Apple', description: 'MacBook Pro, MacBook Air, iMac support. macOS troubleshooting, hardware diagnostics, and software installations.' },
  { id: 5, name: 'ASUS', description: 'ROG, ZenBook, VivoBook support. Gaming optimization, cooling solutions, and performance tuning.' },
  { id: 6, name: 'Acer', description: 'Aspire, Predator, Swift series support. System recovery, driver installation, and hardware repair.' },
  { id: 7, name: 'Microsoft Surface', description: 'Surface Pro, Surface Laptop, Surface Book support. Windows updates, pen calibration, and system optimization.' },
  { id: 8, name: 'Samsung', description: 'Galaxy Book and Notebook support. Display calibration, S Pen support, and system maintenance.' }
];

export const softwareSupport = [
  { id: 1, name: 'Microsoft Office', versions: 'Office 365, Office 2021, Office 2019', description: 'Installation, activation, troubleshooting for Word, Excel, PowerPoint, Outlook, Access, and OneNote.' },
  { id: 2, name: 'Adobe Creative Cloud', versions: 'Photoshop, Illustrator, Premiere Pro, After Effects, InDesign', description: 'Complete Adobe suite installation, licensing, performance optimization, and troubleshooting.' },
  { id: 3, name: 'Adobe Acrobat', versions: 'Acrobat Pro DC, Acrobat Reader', description: 'PDF creation, editing, form filling, and digital signature setup.' },
  { id: 4, name: 'Windows OS', versions: 'Windows 11, Windows 10, Windows Server', description: 'Installation, updates, activation, system recovery, and performance optimization.' },
  { id: 5, name: 'macOS', versions: 'Ventura, Monterey, Big Sur', description: 'macOS installation, Time Machine backup, iCloud setup, and system troubleshooting.' },
  { id: 6, name: 'QuickBooks', versions: 'Desktop & Online versions', description: 'Installation, company file management, data backup, and performance tuning.' },
  { id: 7, name: 'AutoCAD', versions: 'AutoCAD 2024, AutoCAD LT', description: 'Installation, licensing, performance optimization for CAD workstations.' },
  { id: 8, name: 'Other Software', versions: 'Web browsers, Email clients, Media players', description: 'Support for Chrome, Firefox, Thunderbird, VLC, Zoom, Teams, and more.' }
];

export const antivirusSupport = [
  { id: 1, name: 'Norton 360', features: ['Real-time threat protection', 'VPN included', 'Password manager', 'Cloud backup'], description: 'Installation, subscription management, virus removal, and system scans.' },
  { id: 2, name: 'McAfee Total Protection', features: ['Multi-device protection', 'Web protection', 'Firewall', 'Identity theft protection'], description: 'Setup, configuration, threat removal, and performance optimization.' },
  { id: 3, name: 'Kaspersky', features: ['Advanced malware protection', 'Ransomware protection', 'Privacy tools', 'Safe browsing'], description: 'Installation, database updates, deep scans, and security configuration.' },
  { id: 4, name: 'Bitdefender', features: ['AI-powered protection', 'Multi-layer ransomware', 'VPN', 'Anti-phishing'], description: 'Setup, threat detection, system optimization, and protection tuning.' },
  { id: 5, name: 'Avast', features: ['Smart scan', 'Wi-Fi inspector', 'Password manager', 'Browser cleanup'], description: 'Installation, threat removal, scheduled scans, and system maintenance.' },
  { id: 6, name: 'AVG', features: ['Real-time security', 'Email protection', 'Web shield', 'File shield'], description: 'Setup, virus removal, quarantine management, and performance tuning.' },
  { id: 7, name: 'Windows Defender', features: ['Built-in Windows protection', 'Cloud-based protection', 'Controlled folder access', 'Browser protection'], description: 'Configuration, optimization, threat removal, and security hardening.' },
  { id: 8, name: 'Malwarebytes', features: ['Malware removal', 'Ransomware protection', 'Real-time protection', 'Exploit protection'], description: 'Installation, deep scans, threat removal, and system cleanup.' }
];

export const pricingPlans = [
  {
    id: 1,
    name: '1 Year Support',
    price: 1999.99,
    duration: '1 Year',
    features: [
      'Unlimited remote support',
      'Software installation & updates',
      'Virus & malware removal',
      'Performance optimization',
      '24/7 phone support',
      'Email support',
      'Priority response time'
    ],
    popular: false
  },
  {
    id: 2,
    name: '2 Year Support',
    price: 2999.99,
    duration: '2 Years',
    features: [
      'Everything in 1 Year plan',
      'Hardware diagnostics',
      'Data backup assistance',
      'Network troubleshooting',
      'Free software license consultation',
      '2 free onsite visits per year',
      'Extended warranty options'
    ],
    popular: true
  },
  {
    id: 3,
    name: 'Lifetime Support',
    price: 4999.99,
    duration: 'Lifetime',
    features: [
      'Everything in 2 Year plan',
      'Unlimited onsite visits',
      'Free hardware upgrades consultation',
      'Dedicated support specialist',
      'Annual system health checkup',
      'Free minor repairs',
      'Business hours: same-day response',
      'Free system migration assistance'
    ],
    popular: false
  }
];

export const computerSales = [
  {
    id: 1,
    brand: 'Dell',
    model: 'XPS 15',
    category: 'Laptop',
    specs: '13th Gen Intel i7, 16GB RAM, 512GB SSD, 15.6" 4K Display',
    price: 1799.99,
    image: 'https://images.unsplash.com/photo-1618424181497-157f25b6ddd5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxsYXB0b3AlMjBjb21wdXRlcnxlbnwwfHx8fDE3NjA1NzM4NTB8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 2,
    brand: 'HP',
    model: 'EliteBook 840 G9',
    category: 'Laptop',
    specs: 'Intel i7-1255U, 16GB RAM, 512GB SSD, 14" FHD Display',
    price: 1599.99,
    image: 'https://images.pexels.com/photos/34239106/pexels-photo-34239106.jpeg'
  },
  {
    id: 3,
    brand: 'Lenovo',
    model: 'ThinkPad X1 Carbon',
    category: 'Laptop',
    specs: 'Intel i7-1260P, 16GB RAM, 1TB SSD, 14" WUXGA Display',
    price: 1899.99,
    image: 'https://images.unsplash.com/photo-1618424181497-157f25b6ddd5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxsYXB0b3AlMjBjb21wdXRlcnxlbnwwfHx8fDE3NjA1NzM4NTB8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 4,
    brand: 'Apple',
    model: 'MacBook Pro 14"',
    category: 'Laptop',
    specs: 'M3 Pro Chip, 18GB RAM, 512GB SSD, 14.2" Liquid Retina XDR',
    price: 2399.99,
    image: 'https://images.unsplash.com/photo-1511385348-a52b4a160dc2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxsYXB0b3AlMjBjb21wdXRlcnxlbnwwfHx8fDE3NjA1NzM4NTB8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 5,
    brand: 'Dell',
    model: 'OptiPlex 7010',
    category: 'Desktop',
    specs: 'Intel i7-13700, 16GB RAM, 512GB SSD, Windows 11 Pro',
    price: 1299.99,
    image: 'https://images.unsplash.com/photo-1587831990711-23ca6441447b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxkZXNrdG9wJTIwY29tcHV0ZXJ8ZW58MHx8fHwxNzYwNTczODU4fDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 6,
    brand: 'HP',
    model: 'ProDesk 600 G9',
    category: 'Desktop',
    specs: 'Intel i5-12500, 16GB RAM, 256GB SSD, Windows 11 Pro',
    price: 999.99,
    image: 'https://images.pexels.com/photos/38568/apple-imac-ipad-workplace-38568.jpeg'
  }
];

export const antivirusProducts = [
  {
    id: 1,
    name: 'Norton 360 Premium',
    brand: 'Norton',
    category: 'Antivirus',
    coverage: 'Up to 10 Devices',
    duration: '1 Year Subscription',
    features: [
      'Real-time threat protection',
      '100GB Cloud Backup',
      'Secure VPN (unlimited data)',
      'Password Manager',
      'SafeCam for PC',
      'Dark Web Monitoring',
      'Parental Controls',
      '24/7 Customer Support'
    ],
    price: 299.99,
    image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxjeWJlcnNlY3VyaXR5fGVufDB8fHx8MTc3NTE4MTU1M3ww&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 2,
    name: 'McAfee Total Protection',
    brand: 'McAfee',
    category: 'Antivirus',
    coverage: 'Unlimited Devices',
    duration: '2 Year Subscription',
    features: [
      'Award-winning antivirus',
      'Web protection',
      'Firewall protection',
      'Identity theft protection',
      'Secure VPN',
      'Password manager',
      'File encryption',
      'Performance optimization'
    ],
    price: 449.99,
    image: 'https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxjeWJlcnNlY3VyaXR5fGVufDB8fHx8MTc3NTE4MTU1M3ww&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 3,
    name: 'Kaspersky Total Security',
    brand: 'Kaspersky',
    category: 'Antivirus',
    coverage: '5 Devices',
    duration: '2 Year Subscription',
    features: [
      'Advanced anti-malware',
      'Ransomware protection',
      'Privacy tools',
      'Safe money for banking',
      'Webcam protection',
      'Parental controls',
      'File backup & encryption',
      'System performance tools'
    ],
    price: 599.99,
    image: 'https://images.unsplash.com/photo-1614064641938-3bbee52942c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwzfHxkaWdpdGFsJTIwc2VjdXJpdHl8ZW58MHx8fHwxNzc1MTgxNTU5fDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 4,
    name: 'Bitdefender Premium Security',
    brand: 'Bitdefender',
    category: 'Antivirus',
    coverage: '10 Devices',
    duration: '3 Year Subscription',
    features: [
      'AI-powered threat detection',
      'Multi-layer ransomware protection',
      'Premium VPN (unlimited traffic)',
      'Anti-phishing & anti-fraud',
      'Microphone & webcam protection',
      'Priority support 24/7',
      'Password manager',
      'Parental advisor'
    ],
    price: 749.99,
    image: 'https://images.pexels.com/photos/60504/security-protection-anti-virus-software-60504.jpeg'
  },
  {
    id: 5,
    name: 'ESET Smart Security Premium',
    brand: 'ESET',
    category: 'Antivirus',
    coverage: '5 Devices',
    duration: '3 Year Subscription',
    features: [
      'Advanced memory scanner',
      'Botnet protection',
      'Anti-theft features',
      'Password manager',
      'Secure data encryption',
      'Webcam protection',
      'Network attack protection',
      'UEFI scanner'
    ],
    price: 849.99,
    image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxjeWJlcnNlY3VyaXR5fGVufDB8fHx8MTc3NTE4MTU1M3ww&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 6,
    name: 'Trend Micro Maximum Security',
    brand: 'Trend Micro',
    category: 'Antivirus',
    coverage: 'Unlimited Devices',
    duration: '3 Year Subscription',
    features: [
      'AI learning technology',
      'Ransomware protection',
      'Privacy scanner for social media',
      'Secure online banking',
      'Parental controls',
      'System optimizer',
      'Password manager',
      'Fraud protection'
    ],
    price: 999.99,
    image: 'https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxjeWJlcnNlY3VyaXR5fGVufDB8fHx8MTc3NTE4MTU1M3ww&ixlib=rb-4.1.0&q=85'
  }
];

export const sonicWallFirewalls = [
  {
    id: 1,
    model: 'TZ270',
    series: 'TZ Series',
    description: 'Engineered for personal deployment, supporting a single-user environment.',
    features: [
      'Firewall throughput: 1.5 Gbps',
      'Threat prevention: 500 Mbps',
      'VPN throughput: 800 Mbps',
      'Wireless Controller: 16 APs',
      'Max connections: 75,000',
      'Deep packet inspection',
      'Advanced threat protection'
    ],
    price: 14000,
    recommended: 'Small Business (1-10 users)',
    image: 'https://images.unsplash.com/photo-1691435828932-911a7801adfb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxuZXR3b3JrJTIwZmlyZXdhbGx8ZW58MHx8fHwxNzYwNTczODkyfDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 2,
    model: 'TZ470',
    series: 'TZ Series',
    description: 'Purpose-built for individual use with dedicated single-user performance.',
    features: [
      'Firewall throughput: 2.0 Gbps',
      'Threat prevention: 900 Mbps',
      'VPN throughput: 1.2 Gbps',
      'Wireless Controller: 32 APs',
      'Max connections: 300,000',
      'Real-time threat intelligence',
      'Multi-gigabit performance'
    ],
    price: 25000,
    recommended: 'Medium Business (10-50 users)',
    image: 'https://images.unsplash.com/photo-1680691257251-5fead813b73e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxzZXJ2ZXIlMjBoYXJkd2FyZXxlbnwwfHx8fDE3NjA1NzM4OTh8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 3,
    model: 'NSa 2700',
    series: 'NSa Series',
    description: 'Designed for standalone use with secure, single-user functionality.',
    features: [
      'Firewall throughput: 3.5 Gbps',
      'Threat prevention: 2.2 Gbps',
      'VPN throughput: 2.5 Gbps',
      'Max connections: 1,000,000',
      'Advanced anti-malware',
      'SSL/TLS decryption',
      'Zero-touch deployment'
    ],
    price: 35000,
    recommended: 'Enterprise (50-250 users)',
    image: 'https://images.pexels.com/photos/60504/security-protection-anti-virus-software-60504.jpeg'
  },
  {
    id: 4,
    model: 'NSsp 12400',
    series: 'NSsp Series',
    description: 'Built on a single-user framework for streamlined and secure performance.',
    features: [
      'Firewall throughput: 20 Gbps',
      'Threat prevention: 10 Gbps',
      'VPN throughput: 12 Gbps',
      'Max connections: 5,000,000',
      'Multi-instance capability',
      'Advanced routing protocols',
      'High availability options',
      'Cloud management integration'
    ],
    price: 50000,
    recommended: 'Large Enterprise (250+ users)',
    image: 'https://images.pexels.com/photos/1181335/pexels-photo-1181335.jpeg'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Johnson',
    company: 'Johnson & Associates LLC',
    text: 'Microworld Solution saved our business! Our entire network went down, and they had us back up in under 2 hours. Their lifetime support plan is worth every penny.',
    rating: 5
  },
  {
    id: 2,
    name: 'Michael Chen',
    company: 'TechStart Inc.',
    text: 'The best IT support we\'ve ever had. They handled our Microsoft Office migration seamlessly and trained our staff. Highly recommend!',
    rating: 5
  },
  {
    id: 3,
    name: 'Emily Rodriguez',
    company: 'Creative Studios',
    text: 'Our Adobe Creative Cloud setup was a nightmare until Microworld stepped in. They optimized our workstations and now everything runs smoothly.',
    rating: 5
  }
];